import { Pipe, PipeTransform } from '@angular/core';
import { PortalProfileModel } from './portal-profile.models';

@Pipe({
  name: 'portalProfileName',
  standalone: false
})
export class PortalProfileNamePipe implements PipeTransform {
  transform(profile: PortalProfileModel): string {
    if (!profile) return '';
    const parts = [profile.firstName, profile.middleName, profile.lastName].filter(Boolean);
    let name = parts.join(' ');
    if (profile.suffix) {
      name += ', ' + profile.suffix;
    }
    return name;
  }
}
